import api from './api';

export interface ClientProfile {
  id: number;
  name: string;
  description?: string | null;
}

export interface Solicitante {
  id: number;
  nome: string | null;
  email: string;
  telefone: string | null;
  empresa_id: number;
  user_id: number | null;
  role?: string | null;
  group_id?: number | null;
  group_name?: string | null;
  group?: {
    id: number;
    name: string;
    description?: string | null;
  } | null;
  user: {
    id: number;
    name: string;
    email: string;
    enabled?: boolean;
    portal_type: string | null;
  } | null;
  enabled: boolean | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface ListSolicitantesParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  has_user?: string;
  role?: string;
  group_id?: number;
}

export interface BatchSolicitanteDto {
  ids: number[];
  action: 'activate' | 'deactivate' | 'resend_invites' | 'change_profile';
  group_id?: number;
  role?: string;
}

export interface BatchActionResponse {
  success: boolean;
  count: number;
  message: string;
}


export interface CreateSolicitanteDto {
  nome: string;
  email: string;
  telefone?: string;
  create_portal_user?: boolean;
  initial_password?: string;
  send_access_email?: boolean;
  must_change_password?: boolean;
  role_profile?: string;
  role?: string;
  group_id?: number;
  company_ids?: number[];
}

export interface UpdateSolicitanteDto {
  nome?: string;
  email?: string;
  telefone?: string;
  role?: string;
  group_id?: number;
}

export interface RedefinirSenhaDto {
  password?: string;
  send_email?: boolean;
  must_change_password?: boolean;
}

export const solicitantesService = {
  async getPerfis(): Promise<ClientProfile[]> {
    const response = await api.get<ClientProfile[]>('/solicitantes/perfis');
    return response.data;
  },

  async findAll(params?: ListSolicitantesParams): Promise<PaginatedResponse<Solicitante>> {
    const response = await api.get<PaginatedResponse<Solicitante>>('/solicitantes', { params });
    return response.data;
  },

  async findOne(id: number): Promise<Solicitante> {
    const response = await api.get<Solicitante>(`/solicitantes/${id}`);
    return response.data;
  },

  async create(data: CreateSolicitanteDto): Promise<Solicitante> {
    const response = await api.post<Solicitante>('/solicitantes', data);
    return response.data;
  },

  async update(id: number, data: UpdateSolicitanteDto): Promise<Solicitante> {
    const response = await api.patch<Solicitante>(`/solicitantes/${id}`, data);
    return response.data;
  },

  async toggleStatus(id: number): Promise<{ id: number; enabled: boolean; message: string }> {
    const response = await api.patch<{ id: number; enabled: boolean; message: string }>(`/solicitantes/${id}/toggle-status`);
    return response.data;
  },

  async reenviarConvite(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.post<{ success: boolean; message: string }>(`/solicitantes/${id}/reenviar-convite`);
    return response.data;
  },

  async redefinirSenha(id: number, data: RedefinirSenhaDto): Promise<{ success: boolean; message: string; password?: string }> {
    const response = await api.post<{ success: boolean; message: string; password?: string }>(`/solicitantes/${id}/redefinir-senha`, data);
    return response.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/solicitantes/${id}`);
  },

  async batchAction(data: BatchSolicitanteDto): Promise<BatchActionResponse> {
    const response = await api.post<BatchActionResponse>('/solicitantes/batch-action', data);
    return response.data;
  },
};

